import { Injectable, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {  of } from 'rxjs';
import { AbcConfigService } from '@barthauer/abc/core/configuration';


@Injectable({ providedIn: 'root' })
export class BuildInfoService {
  constructor(
    @Optional() 
    @Optional() private config: AbcConfigService
  ) {}

  /**
   * 
   * @returns 
   */
  getFullVersion() {
    const FullVersion = (this.config?.getConfiguration() as any)?.VersionInfo?.Full;
    return of(FullVersion ?? '');
  }

  getMainVersion() {
    const MainVersion = (this.config?.getConfiguration() as any)?.VersionInfo?.Main;
    return of(MainVersion ?? '');
  }

}